(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["partslogic-fitment-verifier"] && !Shopify.designMode) return;
  try {
    
  const renderFitmentVerifier = () => {
        const FitmentVerifier = window.PartslogicUi.FitmentSelectorVerifier;
        const sku = "{{ product.id }}"
        const productDescription = `{{product.description}}`;
        if (productDescription.includes("Universal Fit")) {
            return;
        }
        const FitmentVerifierComponent = window.React.createElement(FitmentVerifier, {
            sku,
            groupId: window.PartslogicUi.groupId,
            styled: true,
            orientation: "vertical",
            title: "Fitment",
            searchButtonText: "Verify",
        });
        const root = window.ReactDOM.createRoot(document.querySelector("#pl-fitment-verifier-{{ product.id }}"));
        root.render(FitmentVerifierComponent);
    }
    if (window.PartslogicUi && window.PartslogicUi.ready) {
        renderFitmentVerifier();
    }
    else {
        window.addEventListener("Partslogic ready", renderFitmentVerifier)
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partslogic-searchbar-desktop"] && !Shopify.designMode) return;
  try {
    
  const hideModal = () => {
        document.querySelector("#pl-search-bar").innerHTML = "";
    }
    const renderModal = (visible) => {
        const SearchBar = window.PartslogicUi.SearchBarWrapperModal;
        const element = document.querySelector("#partslogic-searchbar-modal-desktop")
        const sku = "{{ product.id }}"
        const fitment = localStorage.getItem("sui-fitment-selector-v2");
        const root = window.ReactDOM.createRoot(element);
        const SearchBarComponent = window.React.createElement(SearchBar, {
            onClose: () => {
                root.unmount()
            },
            styled: true,
            show: visible,
            sections: [
                { maxResults: 5, title: 'Categories', type: 'category' },
                { maxResults: 5, title: 'Brands', type: 'brand' },
                { 
                    maxResults: 5, title: 'Products', type: 'product',
                }
            ],           
            onSubmit: (e) => {
                window.location.href = `/search.php?q=${encodeURI(e)}`;
            }
        });
        root.render(SearchBarComponent);
    }
    const clickableSearchBar = document.querySelector("#partslogic-searchbar-trigger-desktop");
    clickableSearchBar.addEventListener("click", () => {
        renderModal(true);
        setTimeout(() => {
            document.querySelector("#sui-search-bar-input").focus();
          }, 200);
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partslogic-searchbar-mobile"] && !Shopify.designMode) return;
  try {
    
  const hideModal = () => {
        document.querySelector("#pl-search-bar").innerHTML = "";
    }
    const renderModal = (visible) => {
        const SearchBar = window.PartslogicUi.SearchBarWrapperModal;
        const element = document.querySelector("#partslogic-searchbar-modal-desktop")
        const sku = "{{ product.id }}"
        const fitment = localStorage.getItem("sui-fitment-selector-v2");
        const root = window.ReactDOM.createRoot(element);
        const SearchBarComponent = window.React.createElement(SearchBar, {
            onClose: () => {
                root.unmount()
            },
            styled: true,
            show: visible,
            sections: [
                { maxResults: 5, title: 'Categories', type: 'category' },
                { maxResults: 5, title: 'Brands', type: 'brand' },
                { 
                    maxResults: 5, title: 'Products', type: 'product',
                }
            ],
            onSubmit: (e) => {
                window.location.href = `/search.php?q=${encodeURI(e)}`;
            }
        });
        root.render(SearchBarComponent);
    }
    const clickableSearchBar = document.querySelector("#partslogic-searchbar-trigger-mobile");
    clickableSearchBar.addEventListener("click", () => {
        renderModal(true)
        setTimeout(() => {
          document.querySelector("#sui-search-bar-input").focus();
        }, 200)
    })

  } catch(e) { console.error(e); }
})();
})();
